/*
 * @Author: Teemo Ding
 * @Date: 2021-09-18 14:09:46
 * @LastEditTime: 2022-06-01 16:57:18
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/ShippingZone/config.tsx
 */
import { calculateCountryAreasText } from '@/src/tools/helper';
import React from 'react';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import styles from './css.module.less';

export const columns = (
  onDelete,
  onEdit,
  countries,
  canEdit,
  canDelete,
  { getI18n },
) => [
  {
    title: getI18n('storeLogistics.shippingZone.shippingZoneName'),
    dataIndex: 'name',
    default: true,
    key: 'name',
    minWidth: 256,
  },
  {
    title: getI18n('storeLogistics.shippingZone.countryArea'),
    dataIndex: 'countryAreas',
    default: true,
    key: 'countryAreas',
    minWidth: 704,
    childGenerate: (countryAreas, record, index) => {
      return (
        <NoWrapContainer>
          <Tooltip
            overlayClassName={styles.overlayClassName}
            title={countryAreas
              .map(
                (item) =>
                  `${item?.country?.name} ${calculateCountryAreasText(
                    item,
                    countries,
                  )}`,
              )
              .join(',')}>
            {countryAreas
              .map(
                (item) =>
                  `${item?.country?.name} ${calculateCountryAreasText(
                    item,
                    countries,
                  )}`,
              )
              .join(',')}
          </Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'name',
    default: true,
    key: 'name',
    minWidth: 128,
    childGenerate: (text, record, index) => (
      <div className={styles.action}>
        {canDelete ? (
          <span className={styles.danger} onClick={() => onDelete(record.uuid)}>
            {getI18n('general.delete')}
          </span>
        ) : null}
        {canEdit ? (
          <span className={styles.primary} onClick={() => onEdit(record)}>
            {getI18n('general.edit')}
          </span>
        ) : null}
      </div>
    ),
  },
];
